export const FastCheckoutActionTypes = {
  REQUEST_FAST_CHECKOUT_PRODUCT: 'REQUEST_FAST_CHECKOUT_PRODUCT',
  REQUEST_FAST_CHECKOUT_PRODUCT_SUCCESS: 'REQUEST_FAST_CHECKOUT_PRODUCT_SUCCESS',
  REQUEST_FAST_CHECKOUT_PRODUCT_FAILURE: 'REQUEST_FAST_CHECKOUT_PRODUCT_FAILURE',
  REQUEST_FAST_CHECKOUT_PURCHASE: 'REQUEST_FAST_CHECKOUT_PURCHASE',
  REQUEST_FAST_CHECKOUT_PURCHASE_SUCCESS: 'REQUEST_FAST_CHECKOUT_PURCHASE_SUCCESS',
  REQUEST_FAST_CHECKOUT_PURCHASE_FAILURE: 'REQUEST_FAST_CHECKOUT_PURCHASE_FAILURE',
  REQUEST_FAST_CHECKOUT_PURCHASE_SET_ERROR: 'REQUEST_FAST_CHECKOUT_PURCHASE_SET_ERROR',
  SET_FAST_CHECKOUT_PRODUCT: 'SET_FAST_CHECKOUT_PRODUCT',
  SET_FASTCHECKOUT_LOADING: 'SET_FASTCHECKOUT_LOADING',
  FASTCHECKOUT_RESET: 'FASTCHECKOUT_RESET',
};

export const FastCheckoutLog = {
  FASTCHECKOUT_CALCULATE_SUCCESS: 'FASTCHECKOUT_CALCULATE_SUCCESS',
  FASTCHECKOUT_CALCULATE_FAILURE: 'FASTCHECKOUT_CALCULATE_FAILURE',
  FASTCHECKOUT_PROCESS_SUCCESS: 'FASTCHECKOUT_PROCESS_SUCCESS',
  FASTCHECKOUT_PROCESS_FAILURE: 'FASTCHECKOUT_PROCESS_FAILURE',
};
